export default __webpack_public_path__ + "static/media/videoPlayerB.d4ab9056.svg";